var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6da900973291d7449cc347a021b5ab5b10b492dd"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["prom@nicholas-gregory"]={id:"6da900973291d7449cc347a021b5ab5b10b492dd"};
      